import React, { ReactNode } from 'react';

export const TabContext = React.createContext(null);

export default function TabContent({
  activeTab,
  children,
}: {
  activeTab: any;
  children: ReactNode;
}) {
  return (
    <TabContext.Provider value={activeTab}>{children}</TabContext.Provider>
  );
}
